import breakpoints from 'muiTheme/config/breakpoints';
import { useState } from 'react';

export enum DeviceType {
    mobile = 'mobile',
    tablet = 'tablet',
    desktop = 'desktop',
    error = 'error',
}

function getDeviceType(): DeviceType {
    if (typeof window === 'undefined') {
        return DeviceType.error;
    }
    if (window.innerWidth <= breakpoints.sm) {
        return DeviceType.mobile;
    }
    if (window.innerWidth <= 1450) {
        return DeviceType.tablet;
    }
    return DeviceType.desktop;
}

const useDeviceType = (): DeviceType => {
    const [deviceType] = useState<DeviceType>(getDeviceType());
    return deviceType;
};

export default useDeviceType;
